import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ProgressBar from '../Components/ProgressBar';
import TextBox from '../Components/Textbox';
import NavigationButtons from '../Components/NavigationButtons.js';
import Navbar from '../Components/Navbar';
import { Box, Text, Image, Flex, VStack, IconButton, Link} from '@chakra-ui/react'; // Import Heading


const SurveyPage1 = ({ surveyData, setSurveyData }) => {
  const [formData, setFormData] = useState(surveyData || {
    name: '',
    phone_number: '',
    email: '',
  });
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleNext = () => {
    setSurveyData(formData);
    navigate('/surveypage2'); // Navigate to the next step
  };
  const handleBack = () => {
    navigate('/resources'); // Change this to the previous step or homepage
  };
  

  return (
    <div>
        <Box bg="#00D29D" w="100%" h="8vh" display="flex" alignItems="center" justifyContent="center">
         <Text fontSize="16px" fontWeight="semibold" mt="1vh">Resources</Text>
        </Box>
        
        <div style={{ padding: '20px', maxWidth: '1200px', margin: 'auto' }}>
        <h2 style={{ font: 'Inter', fontSize: '20px', fontWeight: 'bold', marginTop: '20px' }}>Freelance Preference Survey</h2>
        <p style={{  font: 'Inter', color:'#6E6E6E',  marginBottom: '12px' , fontStyle: 'Italic'}}>Please fill this survey out so that we have a better understanding of how to assist you! :)</p>
        <div style={{ padding: '20px', maxWidth: '1150px', margin: 'auto' }}>
        <ProgressBar step={1} totalSteps={4} />
        </div>
        <h2 style={{ font: 'Inter', fontSize: '16px', fontWeight: 'bold', marginTop: '20px', marginBottom:"5px" }}>What is your name?</h2>
        <TextBox placeholder="Enter text here...." name = 'name' value={formData.name} onChange={handleChange}/>
        <h2 style={{ font: 'Inter', fontSize: '16px', fontWeight: 'bold', marginTop: '20px', marginBottom:"5px" }}>What is your Phone Number?</h2>
        <TextBox placeholder="Enter text here...." name= "phone_number" value={formData.phone_number}  onChange={handleChange} />
        <h2 style={{ font: 'Inter', fontSize: '16px', fontWeight: 'bold', marginTop: '20px', marginBottom:"5px" }}>What is your Email Address?</h2>
        <TextBox placeholder="Enter text here...." name= "email" value={formData.email}  onChange={handleChange} />

        <Box marginTop="150px">
        <NavigationButtons onNext={handleNext} onBack={handleBack} />
        </Box>
      
        <Box marginTop="50px">
        <Navbar/>
        </Box>
        </div>
    </div>
    
  );
};

export default SurveyPage1;
